import React from 'react';
import { Check, Calendar, MapPin, Clock, Globe } from 'lucide-react';
import { Button } from './Button';
import { useLocalCurrency } from '../../hooks/useLocalCurrency';
export function PriceCard() {
  const currency = useLocalCurrency();
  const showLocalPrice = !currency.loading && currency.code !== 'USD';
  return <div id="price-card" className="relative w-full max-w-md mx-auto bg-brand-ivory rounded-3xl shadow-2xl shadow-brand-clay/10 overflow-hidden border border-brand-pistachio" data-id="element-34">
      {/* Top Banner */}
      <div className="bg-brand-clay text-white text-center py-3 text-sm font-medium tracking-wider uppercase" data-id="element-35">
        Cupos Limitados — Solo Mujeres
      </div>

      <div className="p-8 md:p-10" data-id="element-36">
        <div className="text-center mb-8" data-id="element-37">
          <h3 className="text-2xl font-serif font-bold text-brand-dark mb-2" data-id="element-38">
            El Reset Femenino
          </h3>
          <p className="text-brand-text mb-6" data-id="element-39">Evento Presencial de Sanación</p>

          {/* Main USD Price */}
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-40">
            <span className="text-4xl font-serif font-bold text-brand-dark" data-id="element-41">
              $197
            </span>
            <span className="text-brand-text font-medium" data-id="element-42">USD</span>
          </div>

          {/* Local Currency Equivalent */}
          {showLocalPrice && <div className="flex items-center justify-center gap-1.5 mb-3 text-brand-text" data-id="element-43">
              <Globe className="h-3.5 w-3.5" data-id="element-44" />
              <span className="text-sm" data-id="element-45">
                Aprox. {currency.symbol}
                {currency.localPrice} {currency.code} {currency.flag}
              </span>
            </div>}

          {currency.loading && <div className="flex items-center justify-center gap-1.5 mb-3" data-id="element-46">
              <div className="h-3 w-24 bg-brand-pistachio/50 rounded animate-pulse" data-id="element-47"></div>
            </div>}

          <p className="text-brand-clay text-sm font-semibold bg-brand-peach inline-block px-3 py-1 rounded-full" data-id="element-48">
            Precio de Preventa
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-49">
          <div className="flex items-start gap-3 text-brand-text" data-id="element-50">
            <Calendar className="h-5 w-5 text-brand-clay flex-shrink-0 mt-0.5" data-id="element-51" />
            <div data-id="element-52">
              <span className="font-semibold block text-brand-dark" data-id="element-53">
                14 de Marzo
              </span>
              <span className="text-sm text-brand-text" data-id="element-54">Viernes</span>
            </div>
          </div>

          <div className="flex items-start gap-3 text-brand-text" data-id="element-55">
            <Clock className="h-5 w-5 text-brand-clay flex-shrink-0 mt-0.5" data-id="element-56" />
            <div data-id="element-57">
              <span className="font-semibold block text-brand-dark" data-id="element-58">
                10:00 AM – 4:00 PM
              </span>
              <span className="text-sm text-brand-text" data-id="element-59">
                6 horas de inmersión
              </span>
            </div>
          </div>

          <div className="flex items-start gap-3 text-brand-text" data-id="element-60">
            <MapPin className="h-5 w-5 text-brand-clay flex-shrink-0 mt-0.5" data-id="element-61" />
            <div data-id="element-62">
              <span className="font-semibold block text-brand-dark" data-id="element-63">
                Costa Rica 🇨🇷
              </span>
              <span className="text-sm text-brand-text" data-id="element-64">
                Ubicación exacta al reservar
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-3 mb-8 border-t border-brand-pistachio pt-6" data-id="element-65">
          {['Ordenar emociones y energía', 'Soltar cargas invisibles', 'Sanar relación con el dinero', 'Decisiones desde tu verdad', 'Sanación de útero'].map((feature, i) => <div key={i} className="flex items-center gap-3" data-id="element-66">
              <div className="h-5 w-5 rounded-full bg-brand-eucalyptus/30 flex items-center justify-center flex-shrink-0" data-id="element-67">
                <Check className="h-3 w-3 text-brand-dark" data-id="element-68" />
              </div>
              <span className="text-brand-text text-sm" data-id="element-69">{feature}</span>
            </div>)}
        </div>

        <Button fullWidth size="lg" className="shadow-xl shadow-brand-clay/20" onClick={() => window.open('https://pay.hotmart.com/A104324565P?off=pi9fadac', '_blank')} data-id="element-70">
          Reserva tu cupo ahora
        </Button>

        <p className="text-center text-sm text-brand-clay font-medium mt-4" data-id="element-71">
          Entra al link de pago y revisa si la oferta aún está vigente por USD
          $137
        </p>

        <p className="text-center text-xs text-brand-text/60 mt-2" data-id="element-72">
          Pago seguro. Garantía de satisfacción.
        </p>
      </div>
    </div>;
}